import React from "react";
import { t } from "ttag";

import LoadingSpinner from "../../../common/LoadingSpinner";
import { IMattressMatchResult } from "../../../models/catalogue.interfaces";
import { useAppSelector } from "../../reducers";
import { FetchResultsStatusType } from "../constants";
import { mostSimilarProducts } from "../selectors";
import { Result } from "./Result";

import styles from "./Results.module.scss";

export const MattressMatchResults = (): React.JSX.Element => {
    const mattressMatches = useAppSelector((state) =>
        mostSimilarProducts(state.mattressmatch),
    );
    const fetchResultsStatus = useAppSelector(
        (state) => state.mattressmatch.ui.fetchResultsStatus,
    );
    if (fetchResultsStatus === FetchResultsStatusType.ERROR) {
        return (
            <div className={styles.loading}>
                {/* TODO(i18n): Fix awkward phrasing - consider: "No results found for your criteria." or "Unable to find matching products." */}
                <h3>{t`No matching condition with results is found.`}</h3>
            </div>
        );
    }
    if (
        !mattressMatches ||
        fetchResultsStatus === FetchResultsStatusType.LOADING
    ) {
        return (
            <div className={styles.loading}>
                <LoadingSpinner />
            </div>
        );
    }
    return (
        <>
            <div className={styles.results}>
                {mattressMatches.map(
                    (mattressMatchResult: IMattressMatchResult, idx) => {
                        return (
                            <Result
                                key={idx}
                                product={mattressMatchResult.product}
                                productImg={mattressMatchResult.image_url}
                                productCopy={mattressMatchResult.copy}
                                feel={mattressMatchResult.feel}
                                isBestMatch={idx === 0}
                            />
                        );
                    },
                )}
            </div>
        </>
    );
};
